import { useContext, useEffect } from "react";
import { ToolContext } from "../../../../context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const BranchSalesReportWalkthrough = ({ pathname, end, start}) => {

    const {personalization_state} = useContext(ToolContext)
    const {walkthrough} = personalization_state

    const startTour = () =>{
        walkthrough.set((prev) => ({...prev, branchSalesReport:true}))
    }

    const endTour = ()=>{
        walkthrough.set((prev) => ({...prev, branchSalesReport:false}))
    }

    useEffect(() => {
        start("reports", "branch-sales-report", startTour)
        //eslint-disable-next-line
    }, []);

    const steps =[
            {
                content: "Select the branch that you want to generate",
                placement: "right",
                target: "#walkthrough-branch-sales-report-step-1",
                disableBeacon: true
            },
            {
                content: "Select the your target user",
                placement: "right",
                target: "#walkthrough-branch-sales-report-step-2",
                disableBeacon: true
            },
            {
                content: "Select date from",
                placement: "right",
                target: "#walkthrough-branch-sales-report-step-3",
                disableBeacon: true
            },
            {
                content: "Select date to",
                placement: "right",
                target: "#walkthrough-branch-sales-report-step-4",
                disableBeacon: true
            },
            {
                content: "Click Generate",
                placement: "right",
                target: "#walkthrough-branch-sales-report-step-5",
                disableBeacon: true
            },
        ]

    return (
            <JoyrideWrapper 
                run={walkthrough.data.branchSalesReport && window.location.pathname === pathname} 
                steps={steps} 
                setter={endTour} 
                end={end}
                p_name="branch-sales-report" 
                featureName="reports"
            />
        );
}
